import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/empresas/expedientes-de-mercados/';

/**
 * GET ExpedienteMercados
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getExpedientesMercados = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET ExpedienteMercado
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getExpedienteMercado = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST ExpedienteMercado
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postExpedienteMercado = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH ExpedienteMercado
 * @param {number} id
 * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const patchExpedienteMercado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE ExpedienteMercado
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteExpedienteMercado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * GET Expedientes de Mercado para la caja
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */

export const getExpedientesDeMercadoCaja = async (params = null) => {
  try {
    const response = await API.get('/empresas/expedientes-de-mercados-caja/', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
